import {
  TierPracticeFilled,
  TierPracticeOutline,
  TierProFilled,
  TierProOutline,
} from '@heidi/design-system/icons';
import { cn } from '@heidi/utils';

import { CREDIT_USAGE_POPOVER_PRESETS } from './credit-usage-popover-presets';
import type { CreditUsagePopoverPlan, CreditUsageTriggerVariant } from './types';

type CreditUsageTriggerIconProps = {
  plan: CreditUsagePopoverPlan;
  variant?: CreditUsageTriggerVariant;
  size?: number;
  className?: string;
};

/** Tier icon for sidebar `SidebarMenuButton` triggers — not a button itself. */
export function CreditUsageTriggerIcon({
  plan,
  variant = 'tile',
  size = 16,
  className,
}: CreditUsageTriggerIconProps) {
  const { theme } = CREDIT_USAGE_POPOVER_PRESETS[plan];
  const TierIcon =
    plan === 'practiceMax'
      ? variant === 'tile'
        ? TierPracticeFilled
        : TierPracticeOutline
      : variant === 'tile'
        ? TierProFilled
        : TierProOutline;

  return (
    <TierIcon
      size={size}
      className={cn('shrink-0', variant === 'tile' && theme.triggerIconClass, className)}
      aria-hidden
    />
  );
}
